import React from 'react';
import { Dialog } from 'primereact/dialog';

const PlaylistDialog = ({
  visible,
  title,
  subtitle,
  kicker = 'Playlist tools',
  icon = 'pi pi-cog',
  footer,
  onHide,
  children,
  style,
  breakpoints,
  maximized = false,
  contentClassName,
  blockScroll = true,
  className = '',
}) => {
  const header = (
    <div className="playlist-dialog-heading">
      <span className="playlist-dialog-heading__icon" aria-hidden="true">
        <i className={icon}></i>
      </span>
      <div className="playlist-dialog-heading__text">
        <span className="playlist-dialog-heading__kicker">{kicker}</span>
        <strong>{title}</strong>
        {subtitle && <span className="playlist-dialog-heading__subtitle">{subtitle}</span>}
      </div>
    </div>
  );

  return (
    <Dialog
      visible={visible}
      header={header}
      modal
      className={`cleanDialog playlist-modern-dialog ${className}`.trim()}
      maskClassName="cleanDialogMask playlist-modern-dialog-mask"
      style={style}
      breakpoints={breakpoints}
      maximized={maximized}
      contentClassName={contentClassName}
      footer={footer}
      blockScroll={blockScroll}
      onHide={onHide}
    >
      {children}
    </Dialog>
  );
};

export default PlaylistDialog;
